import { useContext } from "react";
import { LoaderContext, LoaderContextProps } from "../context/loaderContext";

export const useLoader = (): LoaderContextProps => {
    const context = useContext(LoaderContext);
    if (!context) {
        throw new Error("useLoader Error");
    }
    return context;
};